<div class="form-group">
  <div class="row align-items-center">
    <div class="col-lg">
      <h3 class="h5 fw-normal">Mailing Address</h3>
    </div>
    <div class="col-lg text-end">
      @if (!addAddressMode() && !address()) {
        <div>
          <button class="btn btn-primary btn-sm" (click)="enableAddAddress()">Add</button>
        </div>
      }
    </div>
  </div>
  <ul class="list-group mt-3">
    @if (!dataLoaded()) {
      <li class="list-group-item">
        <ngx-skeleton-loader count="1" [theme]="{ height: '5rem' }"></ngx-skeleton-loader>
      </li>
    } @else if (!addAddressMode() && dataLoaded()) {
      <li class="list-group-item clickable" (click)="loadEditForm()">
        @if (!!address()) {
          <div class="d-flex justify-content-between my-1">
            <div class="h6 fw-normal">
              {{ address()!.line1 }} {{ address()!.line2 }} <br />
              {{ address()!.city }}
              @if (address()!.stateCode != null) {
                <span>, {{ address()!.stateCode }}</span>
              }
              @if (address()!.cityStateProvince != null) {
                <span>{{ address()!.cityStateProvince }}</span>
              }
              {{ address()!.zipCode }}
              @if (address()!.zipPlusFourCode) {
                <span>+{{ address()!.zipPlusFourCode }}</span>
              }
              <br />
              @if (address()!.country) {
                {{ address()!.country }}
              }
            </div>
            <div>
              <i certTooltip="Edit" class="edit-icon-lg"></i>
            </div>
          </div>
        }

        @if (!address()) {
          <p class="h6 fw-normal m-1 py-3">There is no address on file for this educator</p>
        }
      </li>
    } @else if (addAddressMode() && dataLoaded()) {
      <li class="list-group-item">
        <edportal-educator-contact-address-form
          [address]="selectedAddress()!"
          [states]="states()"
          (addressChanged)="handleFormEvent($event)"
        ></edportal-educator-contact-address-form>
      </li>
    }
  </ul>
</div>
